import { render } from "./ParamInvoiceTaxRateForm.vue?vue&type=template&id=59d3afb8&ts=true"
import script from "./ParamInvoiceTaxRateForm.vue?vue&type=script&lang=ts"
export * from "./ParamInvoiceTaxRateForm.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__